const bannerClasses =
  'flex items-start gap-3 mb-4 p-3 rounded-lg ' +
  'bg-primary-surface border border-primary-light-2 text-content';

const iconClasses = 'fa fa-info-circle text-primary mt-0.5';

const LifecareStudioNewPlanBanner = () => (
  <div className={bannerClasses}>
    <i className={iconClasses} />
    <div>
      <p className="m-0 font-semibold text-sm">Start a new structured lifecare plan</p>
      <p className="m-0 text-xs text-subtle">
        This client does not have a structured plan yet. Fill in the sections below and your
        edits will autosave. The next preview will render this plan as the PDF.
      </p>
    </div>
  </div>
);

export default LifecareStudioNewPlanBanner;
